export class IdHelper {

	public static newGuid(): string {
	    return 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });	
	} 

	public static getConditionId(componentId: string, conditionIndex: number): string {
		return componentId + "_" + conditionIndex;
	}
	public static isValidGuid(guidString:string) : boolean {
		var validGuidCheck = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/;
		return validGuidCheck.test(guidString);
	}

}


// WEBPACK FOOTER //
// ./source/ts/helpers/id.ts